import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const HomeBanners = superstyled({
  tag: Box,
  name: 'HomeBanners',
  slot: 'HomeBanners',
  styles: () => ({
    marginBlockEnd: '1.5rem',

    // Remove margin if there is not any content/banners.
    '&:empty': {
      marginBlockEnd: 0,
    },

    '& > :first-of-type': {
      marginTop: 0,
    },
  }),
});
